import value from "./value";
export default function theme(name, values) {
  return props => value(name, props, values);
}
//# sourceMappingURL=theme.js.map